/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Score_AnatomyInputs */

const en_directory_detail_score_anatomy = /** @type {(inputs: Directory_Detail_Score_AnatomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score anatomy`)
};

const zh_directory_detail_score_anatomy = /** @type {(inputs: Directory_Detail_Score_AnatomyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评分构成`)
};

/**
* | output |
* | --- |
* | "Score anatomy" |
*
* @param {Directory_Detail_Score_AnatomyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_score_anatomy = /** @type {((inputs?: Directory_Detail_Score_AnatomyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Score_AnatomyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_score_anatomy(inputs)
	return zh_directory_detail_score_anatomy(inputs)
});
export { directory_detail_score_anatomy as "directory.detail.score_anatomy" }